export default function ccpaDeletedMemberRedirect() {
  const url = window.location.href;

  if (url.match(/[?]modalType=mt_deletedMember/)) {
    window.location = window.location.href.replace('?modalType=mt_deletedMember', '#modalType=mt_deletedMember');
  }
}
